import React, { useState } from 'react';
import { MenuButton } from '../../helperComponents/MenuButton';
import { GAME_TYPES_TYPE } from '../../../constants/constants';

import { UniversalProps } from '../../../typesInterfacesEnums/componentProps';
import { lobbyButtonSharedProps, ButtonRowDivider } from './utils';
import { Divider } from '../../helperComponents/Divider';
import { Pressable, StyleSheet, Text } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { HowToPlay } from '../../helperComponents/HowToPlay';
import HowToPlayButton from '../../HowToPlayButton';
import { IconRightTextButton } from '../../helperComponents/Button/IconRightTextButton';
import { GraphIconV2Icon } from '../../../resources/svgComponents/GraphIconV2';
import { IconTextButton } from '../../helperComponents/Button/IconTextButton';
import { USER_TYPES } from '../../../typesInterfacesEnums/enums';
import { useSignedInContext } from '../../../context/SignedInContext';

const bee1Icon = require('../../../resources/images/bee1.png');
const bee2Icon = require('../../../resources/images/bee2.png');
const bee4Icon = require('../../../resources/images/bee3.png');

const HiveGymLobby = ({
  navigation,
  playingName,
}: {
  navigation: UniversalProps['navigation'];
  playingName: string | undefined;
}) => {
  const [isHowToPlayOpen, setHowToPlayOpen] = useState(false);
  const route = useRoute();
  const { user } = useSignedInContext();

  return (
    <>
      <MenuButton
        onPress={() => {
          const currentParams = route.params || {};
          navigation.navigate('Lobby', {
            ...currentParams,
            playAFriend: true,
          });
        }}
        colors={['#90DF75', '#62B655']}
        text="Play a friend"
        image={bee2Icon}
        {...lobbyButtonSharedProps}
      />
      <ButtonRowDivider />
      <MenuButton
        onPress={() => {
          const currentParams = route.params || {};
          navigation.navigate('SelectGameType', {
            ...currentParams,
            next: 'PlayWithAI',
            userName: playingName,
          });
        }}
        colors={['#747474', '#1F1F1F']}
        text="Practice vs BOT"
        image={bee4Icon}
        {...lobbyButtonSharedProps}
      />
      <ButtonRowDivider />
      {/*TODO: fix navigation to test yourself page */}
      <MenuButton
        onPress={() => {
          const currentParams = route.params || {};
          navigation.navigate('SelectGameType', {
            ...currentParams,
            gymAssessment: true,
            gym: true,
          });
        }}
        colors={['#FF9252', '#FF3F15']}
        text="Buzz Practice"
        image={bee1Icon}
        {...lobbyButtonSharedProps}
      />
      <ButtonRowDivider />
      <Divider empty height={10} />
      {/* <Text maxFontSizeMultiplier={1} style={styles.howToPlayText}>
          How to play?
        </Text> */}

      <IconTextButton
        onPress={() => {
          const currentParams = route.params || {};
          navigation.navigate('GymStats');
        }}
        text="Gym Stats"
        icon={<GraphIconV2Icon />}
      />
    </>
  );
};

const styles = StyleSheet.create({
  howToPlayText: {
    fontFamily: 'Secular One',
    fontSize: 20,
    color: 'black',
    textDecorationLine: 'underline',
  },
});

export { HiveGymLobby };
